import { render, staticRenderFns } from "./Openingstatistics.vue?vue&type=template&id=48291998"
import script from "./Openingstatistics.vue?vue&type=script&lang=js"
export * from "./Openingstatistics.vue?vue&type=script&lang=js"
import style0 from "./Openingstatistics.vue?vue&type=style&index=0&id=48291998&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports